import React from 'react'
import { useMediaQuery } from 'react-responsive'

import { mediaSize } from 'shared/style/var'

interface IDefineDeviceComponentProps {
  [key: string]: React.ReactElement
}

export const DefineDeviceComponent: React.FC<IDefineDeviceComponentProps> = ({ desktopComponent, mobileComponent }) => {
  const isMobileOfTablet = useMediaQuery({ maxWidth: mediaSize.laptop })
  return isMobileOfTablet ? mobileComponent : desktopComponent
}
